import FaqItem from './FaqItem'

export default FaqItem